import React from 'react';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdEdit as EditIcon } from 'react-icons/md';

export const roomTypes = [
  { value: 'bathroom', primaryText: 'Bathroom' },
  { value: 'bedroom', primaryText: 'Bedroom' },
  { value: 'den', primaryText: 'Den' },
  { value: 'office', primaryText: 'Office' },
  { value: 'entrance', primaryText: 'Entrance' },
  { value: 'exterior_back', primaryText: 'Exterior Back' },
  { value: 'exterior_front', primaryText: 'Exterior Front' },
  { value: 'parkade', primaryText: 'Parkade' },
  { value: 'hallway', primaryText: 'Hallway' },
  { value: 'kitchen', primaryText: 'Kitchen' },
  { value: 'laundry', primaryText: 'Laundry' },
  { value: 'living_area', primaryText: 'Living Area' },
  { value: 'locker', primaryText: 'Locker' },
  { value: 'mechanical', primaryText: 'Mechanical' },
  { value: 'stairway', primaryText: 'Stairway' },
  { value: 'meeting_room', primaryText: 'Meeting Room' },
  { value: 'storage', primaryText: 'Storage' },
  { value: 'unlisted', primaryText: 'Unlisted' },
];

export const SavedRooms = ({ items, onEdit, onDelete, disabled }) => {
  const getRoomType = (item) => {
    if (item.room_type === undefined) return '';
    return roomTypes.find((room) => room.value === item.room_type).primaryText;
  };

  const renderRoomDetails = (item) => {
    if (item.rooms === undefined || item.rooms.length === 0) return null;
    return (
      <div className="row">
        <div className="col-sm-4" style={{ paddingLeft: '0px' }}>
          <p>{item.rooms.length} rooms associated</p>
        </div>
      </div>
    );
  };

  return (
    <div>
      {items.map((item, index) => {
        const name = item.name ? `${item.name} - ${getRoomType(item)}` : '';
        return (
          <div
            id="mobile_card"
            key={index}
            style={{ paddingBottom: '0px', textTransform: 'capitalize' }}
          >
            {!disabled && onDelete && (
              <IconButton
                style={{ float: 'right', padding: '0px', height: '1px' }}
                onClick={() => onDelete(index)}
              >
                <DeleteIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            {!disabled && onEdit && (
              <IconButton
                style={{ float: 'right', padding: '0px', marginRight: '25px', height: '1px' }}
                onClick={() => onEdit(index)}
              >
                <EditIcon size={24} style={{ padding: '0px' }} />
              </IconButton>
            )}

            <div className="row">
              <div className="mobile_header">
                <p>{name}</p>
              </div>
              <div className="mobile_subheader">{renderRoomDetails(item)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
